<app-header [user]="user()" [accountOrders]="accountOrders()" />
<router-outlet />
